import { Icon } from '@/src/components/ui';
import { Button } from '@workspace/ui/components/button';

type Props = {
  onBack?: () => void;
  step: number;
  totalSteps: number;
  goToStep: (step: number) => void;
};

export const StepsFooter = ({ onBack, step, totalSteps, goToStep }: Props) => {
  return (
    <div className="flex justify-between items-center w-full max-w-[650px]">
      <Button
        variant="ghost"
        onClick={onBack}
        className="px-4 py-3.5 rounded-[8px] border-0 md:text-sm text-xs h-10 hover:bg-button-tertiary transition duration-300 ease-in-out cursor-pointer"
      >
        <Icon name="back" className="size-2.5" />
        Back
      </Button>

      <div className="flex justify-center space-x-2 flex-1">
        {Array.from({ length: totalSteps }, (_, i) => i + 1).map((s) => (
          <div
            key={s}
            className={`cursor-pointer h-2 rounded-full transition-all duration-200 ${
              s === step ? 'bg-black w-16' : 'bg-gray-300 w-2'
            }`}
            onClick={() => goToStep(s)}
          />
        ))}
      </div>

      <span className="text-xs md:text-sm font-light text-black/60">
        Step {step}/{totalSteps}
      </span>
    </div>
  );
};

